/**
 * ч.849: двоколонковий каркас сторінки документа — ліворуч пронумеровані
 * блоки полів (DocBlock), праворуч рейка (DocRail).
 */
import type { ReactNode } from 'react';

export default function DocLayout({ children, rail }: {
  children: ReactNode;
  rail: ReactNode;
}) {
  return (
    <div className="doclayout">
      <div className="doclayout__main">{children}</div>
      {rail}
    </div>
  );
}
